import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { PaymentInfo } from './PaymentInfo';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-32 overflow-hidden" data-id="element-52">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-dark-900 z-0" data-id="element-53">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-dark-800 via-dark-900 to-dark-900" data-id="element-54"></div>
        {/* Abstract grip/vein lines using CSS */}
        <div className="absolute inset-0 opacity-20" data-id="element-55">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-56">
            <defs data-id="element-57">
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-58">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1A1A1A" strokeWidth="1" data-id="element-59" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" data-id="element-60" />
            <path d="M-100,500 Q200,300 500,600 T1200,400" fill="none" stroke="#00F0FF" strokeWidth="2" opacity="0.3" className="animate-pulse" data-id="element-61" />
            <path d="M-100,600 Q300,400 600,700 T1300,500" fill="none" stroke="#00F0FF" strokeWidth="1" opacity="0.1" data-id="element-62" />
          </svg>
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-neon-cyan/5 rounded-full blur-[120px] pointer-events-none" data-id="element-63"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-5xl mx-auto" data-id="element-65">
          <div className="inline-block mb-6 px-8 py-3 border border-neon-cyan/30 rounded-full bg-neon-cyan/5 backdrop-blur-sm" data-id="element-66">
            <span className="text-neon-cyan font-oswald tracking-widest text-xl md:text-2xl font-bold" data-id="element-67">
              SISTEMA TRIGRIP™
            </span>
          </div>

          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-6 leading-[0.9]" data-id="element-68">
            <span className="block text-white" data-id="element-69">TU CUERPO ES FUERTE.</span>
            <span className="block text-neon-cyan text-shadow-neon mt-2" data-id="element-70">
              TU AGARRE NO.
            </span>
          </h1>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="text-xl md:text-3xl text-gray-300 mb-12 max-w-3xl mx-auto font-inter font-light" data-id="element-71">
            Convertí tu agarre en una ventaja real de{' '}
            <strong className="text-white font-bold" data-id="element-72">fuerza</strong>,{' '}
            <strong className="text-white font-bold" data-id="element-73">control</strong> y{' '}
            <strong className="text-white font-bold" data-id="element-74">dominio</strong>.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.6,
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} className="flex justify-center" data-id="element-75">
            <Button size="xl" data-id="element-76">
              QUIERO DOMINAR MI AGARRE <ChevronRight className="w-6 h-6 ml-2" data-id="element-77" />
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1
        }} data-id="element-78">
            <PaymentInfo data-id="element-79" />
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-80">
        <span className="text-xs text-gray-500 tracking-widest uppercase mb-2" data-id="element-81">
          Descubrir
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-neon-cyan/50 to-transparent" data-id="element-82"></div>
      </motion.div>
    </section>;
}